import React, {useEffect, useState} from 'react'
import ConfigUtil from "../../../util/ConfigUtil";
import FetchUtil from "../../../util/FetchUtil";
import {NavLink} from "react-router-dom";
import {NAVIGATION_ITEM} from "../../../constants/navigationItems";
// gleiches Design wie die Weiterleitung nach dem Scorer-Update und die Teilnahmebestätigung
import "../../scorer/scorerRedirect.css";

export default function ParticipantDeregistration({id, startseiteUrl}) {

    const [infoMessage, setInfoMessage] = useState("");
    const [errorMessage, setErorMessage] = useState("");
    // Event des Teilnehmers für den Knopf "Zum Event". Kommt auch, wenn das Event schon gestartet ist und nicht mehr abgemeldet werden kann.
    const [tournamentId, setTournamentId] = useState(undefined);

    useEffect(() => {
        abschliessen();
    }, []);

    const abschliessen = () => {
        setErorMessage("");
        if (id === null || id === undefined || id === "") {
            setErorMessage("Aufruf dieser Seite ohne eine ID ist nicht erlaubt.");
            return;
        }

        let url = ConfigUtil.getConfig().resourceUrls.public + "/participantderegistration/" + id;
        FetchUtil.fetchPost(url,
            {},
            ergebnis => {
                setTournamentId(ergebnis.tournamentId);
                if( ergebnis.fehlermeldung === null || ergebnis.fehlermeldung === undefined) {
                    setInfoMessage("Deine Teilnahme am Event wurde storniert. Weiterhin good darts...");
                } else {
                    setErorMessage(ergebnis.fehlermeldung);
                }
            },
            responseNotOk => {
                setErorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErorMessage("Fehler: " + error);
            }
        );
    }

    const getStatus = () => {
        if (errorMessage !== "") {
            return {klasse: "dhsr-status-fehler", icon: "pi pi-times", titel: "Abmeldung nicht möglich", text: errorMessage};
        }
        if (infoMessage !== "") {
            return {klasse: "dhsr-status-erfolg", icon: "pi pi-check", titel: "Abmeldung erfolgreich", text: infoMessage};
        }
        return {klasse: "dhsr-status-laden", icon: "pi pi-spin pi-spinner", titel: "Du wirst abgemeldet", text: "Bitte einen Moment Geduld …"};
    }

    const status = getStatus();

    return <div className="dhsr-seite">
        <main className="dhsr-karte">
            <a href={startseiteUrl} aria-label="Zur Startseite">
                <img className="dhsr-logo" alt="Darthelfer" src={"/images/darthelfer_quer_weiss.png"}/>
            </a>

            <div className={"dhsr-status " + status.klasse} aria-hidden="true">
                <i className={status.icon}/>
            </div>

            <div role="status" aria-live="polite">
                <h1 className="dhsr-titel">{status.titel}</h1>
                <p className="dhsr-text dhsr-abstand">{status.text}</p>
            </div>

            {tournamentId &&
                <NavLink className="dhsr-knopf" to={NAVIGATION_ITEM.PUBLIC_TOURNAMENT.route + "/" + tournamentId}>
                    Zum Event
                    <i className="pi pi-arrow-right" aria-hidden="true"/>
                </NavLink>
            }

            <a className="dhsr-link" href={startseiteUrl}>
                <i className="pi pi-home" aria-hidden="true"/>
                Zur Startseite
            </a>
        </main>
    </div>
}
